<template>
  <div class="pa-2">
    <span class="mr-5">
      <v-icon> mdi-filter-variant </v-icon>
    </span>
    <ProductoSucursalFiltroCategoria></ProductoSucursalFiltroCategoria>
    <!-- <ProductoSucursalFiltroMarca></ProductoSucursalFiltroMarca> -->
    <!-- <ProductoSucursalFiltroPlataforma></ProductoSucursalFiltroPlataforma> -->
    <ProductoSucursalFiltroProveedor></ProductoSucursalFiltroProveedor>

    <v-list-item v-if="false">
      <v-list-item-content>
        <v-list-item-title>
          <span style="font-size: 14px">Stock</span></v-list-item-title
        >
        <v-row justify="center" class="mt-1">
          <v-col cols="5">
            <v-text-field
              background-color="#424242"
              outlined
              dense
              placeholder="Mín."
              >|</v-text-field
            >
          </v-col>
          <div class="mt-5" style="display: block">a</div>
          <v-col cols="5">
            <v-text-field
              background-color="#424242"
              outlined
              dense
              placeholder="Máx."
            ></v-text-field>
          </v-col>
        </v-row>
      </v-list-item-content>
    </v-list-item>
  </div>
</template>

<script>
import ProductosFiltrosTag from "@/components/producto/filtros/productos.filtros.tag.vue";
import ProductoFiltroPlataforma from "@/components/producto/filtros/producto.filtro.plataforma.vue";
import ProductoFiltroProveedor from "@/components/producto/filtros/producto.filtro.proveedor.vue";
import ProductoSucursalFiltroCategoria from "@/components/producto/filtros/ProductoSucursalFiltroCategoria.vue";
import ProductoSucursalFiltroMarca from "@/components/producto/filtros/ProductoSucursalFiltroMarca.vue";
import ProductoSucursalFiltroPlataforma from "@/components/producto/filtros/ProductoSucursalFiltroPlataforma.vue";
import ProductoSucursalFiltroProveedor from "@/components/producto/filtros/ProductoSucursalFiltroProveedor.vue";

import { mapActions, mapMutations } from "vuex";
import ProductoFiltroSucursal from "@/components/producto/filtros/producto.filtro.sucursal.vue";

export default {
  name: "ProductosSucursalFiltros",
  components: {
    ProductosFiltrosTag,
    ProductoFiltroPlataforma,
    ProductoFiltroProveedor,
    ProductoSucursalFiltroCategoria,
    ProductoSucursalFiltroMarca,
    ProductoSucursalFiltroPlataforma,
    ProductoSucursalFiltroProveedor,
    ProductoFiltroSucursal,
  },
  props: {
    withTags: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      plataformas: [
        { id: 1, nombre: "Pedidos Ya", key: "plataforma-pedidosya" },
        { id: 1, nombre: "Mi sistema", key: "paltaforma-misistema" },
      ],
      filters: [],
      categoriaFilter: null,
    };
  },
  computed: {
    get_querys2() {
      const chipsArray = [];

      // Iterar a través de las propiedades en los parámetros de consulta
      for (const property in this.$route.query) {
        // Dividir los valores de la propiedad por '%7C' para obtener valores individuales
        const valuesArray = this.$route.query[property].split("%7C");

        // Iterar a través de los valores individuales
        for (const value of valuesArray) {
          // Dividir los valores individuales por '|' para obtener valores más individuales
          const individualValues = value.split("|");

          // Iterar a través de los valores más individuales y crear chips
          for (const individualValue of individualValues) {
            // Transformar el valor en el nombre deseado
            console.log("individualValue", individualValue);
            const nombre = this.get_text_transform(individualValue);

            // Crear un objeto chip y agregarlo al array
            const chip = {
              key: property,
              value: individualValue,
              nombre: nombre,
            };
            chipsArray.push(chip);
          }
        }
      }

      // Devolver el array de chips
      return chipsArray;
    },
  },
  methods: {
    ...mapActions("categorias", ["fetchCategoriasProductosFiltros"]),
    ...mapMutations("categorias", [
      "SET_CATEGORIAS_PRODUCTOS_FILTROS_SELECCIONADO",
    ]),
    get_querys(parametro) {
      const chipsArray = [];

      // Solo procesar si existe el parámetro en la query
      const queryValue = this.$route.query[parametro];
      if (queryValue) {
        // Dividir por '%7C' (que es '|')
        const valuesArray = queryValue.split("%7C");

        for (const value of valuesArray) {
          // Dividir nuevamente por '|' por si viene sin codificar
          const individualValues = value.split("|");

          for (const individualValue of individualValues) {
            const nombre = this.get_text_transform(individualValue);

            const chip = {
              key: parametro,
              value: individualValue,
              nombre: nombre,
            };
            chipsArray.push(chip);
          }
        }
      }

      return chipsArray;
    },
    loadCategoria(name) {
      this.$refs.categoriaList.load(name);
    },
    closeChip(chip) {
      console.log("CHIP", chip);
      if (chip.key == "categoria") {
        this.$refs.categoriaList.loadRoot();
      }
    },
    addTag(tag) {
      console.log(tag);
      var object = {};
      object[tag.key] = tag.value;
      return object;
    },
    get_text_transform(str) {
      if (typeof str === "string") {
        return str.match(/[^ ]+/g).join("-");
      } else {
        return str;
      }
    },

    // Método para agregar parámetros de consulta a la URL actual y manejar valores duplicados
    add_query_url(value) {
      console.log("add_query_url", value);
      const existingQuery = this.$route.query;
      const querys = { ...existingQuery }; // Copiamos los parámetros actuales a un nuevo objeto

      for (const key in value) {
        if (querys.hasOwnProperty(key)) {
          const existingValues = querys[key].split("|"); // Dividimos los valores existentes
          if (existingValues.includes(value[key])) {
            // Si el valor ya existe, lo eliminamos del array
            existingValues.splice(existingValues.indexOf(value[key]), 1);
            if (existingValues.length === 0) {
              // Si no quedan valores, eliminamos la clave
              delete querys[key];
            } else {
              querys[key] = existingValues.join("|"); // Actualizamos los valores de la clave
            }
          } else {
            console.log("value[key]", value[key]);
            existingValues.push(value[key]); // Agregamos el valor al array
            querys[key] = existingValues.join("|"); // Actualizamos los valores de la clave
          }
        } else {
          console.log("value[key]", value[key]);

          querys[key] = value[key]; // Agregamos el valor directamente si la clave no existe
        }
      }

      // Reemplazamos la URL actual con los nuevos parámetros de consulta actualizados
      this.$router.replace({ query: querys }).catch((error) => {
        // Manejamos el error de navegación duplicada (NavigationDuplicated)
        if (error.name !== "NavigationDuplicated") {
          throw error;
        }
      });
    },

    setProveedor(data) {
      const transformedData = {
        proveedor: this.get_text_transform(data.nombre),
      };
      this.add_query_url(transformedData);
    },
    setPedidosYa() {
      const transformedData = {
        py: true,
      };
      this.add_query_url({ py: true });
    },
    setMarca(data) {
      const transformedData = {
        marca: this.get_text_transform(data.nombre),
      };
      this.add_query_url(transformedData);
    },
    setSucursal(data) {
      console.log("setSucursal", data);
      const transformedData = {
        sucursal: data.nombre,
      };
      this.add_query_url(transformedData);
    },
    setCategoria(data) {
      console.log(data);

      this.categoriaFilter = data.name;
      this.SET_CATEGORIAS_PRODUCTOS_FILTROS_SELECCIONADO(data);
      this.fetchCategoriasProductosFiltros(data.name);
      const transformedData = {
        categoria: this.get_text_transform(data.name),
      };
      this.add_query_url(transformedData);
      this.$emit("set-categoria", data);
    },
    remove_query_url(key, valueToRemove) {
      let queryParams = Object.assign({}, this.$route.query);

      if (queryParams.hasOwnProperty(key)) {
        // Dividimos los valores por '|'
        const valuesArray = queryParams[key].split("|");

        // Filtramos los valores para mantener solo los que no coinciden con el valor a eliminar
        const filteredValues = valuesArray.filter(
          (value) => value !== valueToRemove
        );

        // Si quedan valores después de la eliminación, los unimos con '|'
        if (filteredValues.length > 0) {
          queryParams[key] = filteredValues.join("|");
        } else {
          // Si no quedan valores, eliminamos la clave
          delete queryParams[key];
        }

        this.$router.replace({ query: queryParams }).catch((error) => {
          if (error.name !== "NavigationDuplicated") {
            throw error;
          }
        });
      }
    },

    replaceParams(categoria) {
      var string = categoria.name.split(/[ ]+/).join("-");
      return string;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>